import { createContext, type ReactNode, useContext } from "react";

type PageNameContext = {
  pageName: string;
};

const PageNameContext = createContext<PageNameContext | null>(null);

PageNameContext.displayName = "PageNameContext";

const PageNameProvider = ({ value, children }: { value: PageNameContext; children: ReactNode }) => {
  return <PageNameContext.Provider value={value}>{children}</PageNameContext.Provider>;
};
PageNameProvider.displayName = PageNameProvider.name;

const usePageName = (): PageNameContext => {
  const context = useContext(PageNameContext);
  if (!context) {
    throw new Error("No context found for PageName");
  }
  return context;
};

export { PageNameContext, PageNameProvider, usePageName };
